import React from 'react';
interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}
const BackIcon: React.FC<IconProps> = ({
  color = '#083E60',
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.90393 9.5698L1.45133 10.0042L1 9.5698L1.45133 9.13541L1.90393 9.5698ZM23 19.3865C23 19.5492 22.9326 19.7052 22.8128 19.8203C22.6929 19.9354 22.5303 20 22.3607 20C22.1912 20 22.0286 19.9354 21.9087 19.8203C21.7888 19.7052 21.7214 19.5492 21.7214 19.3865H23ZM7.84407 16.1396L1.45133 10.0042L2.35654 9.13541L8.74929 15.2708L7.84407 16.1396ZM1.45133 9.13541L7.84407 3L8.74929 3.86877L2.35654 10.0042L1.45133 9.13541ZM1.90393 8.95626H14.6894V10.1833H1.90393V8.95626ZM23 16.9323V19.3865H21.7214V16.9323H23ZM14.6894 8.95626C16.8935 8.95626 19.0074 9.79659 20.5659 11.2924C22.1244 12.7882 23 14.8169 23 16.9323H21.7214C21.7214 15.1424 20.9806 13.4257 19.6618 12.1601C18.3431 10.8944 16.5544 10.1833 14.6894 10.1833V8.95626Z'
        fill={color}
      />
    </svg>
  );
};

export default BackIcon;
